import { supabaseRealtimeProvider } from "../../providers/supabase/realtime";

const realtimeProvider = supabaseRealtimeProvider;

/**
 * Suscribe una función callback a cambios en una tabla.
 * @param {string} channelName - Nombre único del canal.
 * @param {string} table - Tabla a escuchar.
 * @param {string} event - Evento ('*' | 'INSERT' | 'UPDATE' | 'DELETE').
 * @param {function} callback - Función manejadora del payload.
 * @returns {function} Función de limpieza para desuscribirse.
 */
export const subscribeToTable = (channelName, table, event, callback, filter) => {
  return realtimeProvider.subscribeToTable(channelName, table, event, callback, filter);
};

/**
 * Suscribe a múltiples tablas en un solo canal.
 * @param {string} channelName - Nombre único del canal agrupado.
 * @param {Array<{table: string, event: string, callback: function}>} subscriptions - Arreglo de suscripciones.
 * @returns {function} Función de limpieza.
 */
export const subscribeGroup = (channelName, subscriptions) => {
  return realtimeProvider.subscribeGroup(channelName, subscriptions);
};
